import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LANGUAGE } from '@src/constants';
import { PAYMENT_METHOD_TYPE } from '@src/constants/payment';
import Tooltip from '@src/components/Tooltip';
import iconPaymentMethodGg from '@src/assets/icons/payment-method-gg.svg';
import iconPaymentMethodApple from '@src/assets/icons/payment-method-apple.svg';
import iconPaymentMethodMomo from '@src/assets/icons/payment-method-momo.png';
import iconPaymentMethodNapasAccount from '@src/assets/icons/payment-method-napas-account.svg';
import iconPaymentMethodNapasCard from '@src/assets/icons/payment-method-napas-card.svg';
import iconMasterCard from '@src/assets/icons/master-card.png';

const PaymentMethod = ({ paymentMethodType, paymentMethod }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const getPaymentMethodIcon = () => {
    switch (paymentMethodType) {
      case PAYMENT_METHOD_TYPE.APPLE:
        return iconPaymentMethodApple;
      case PAYMENT_METHOD_TYPE.GOOGLE:
        return iconPaymentMethodGg;
      case PAYMENT_METHOD_TYPE.MOMOPAY:
        return iconPaymentMethodMomo;
      case PAYMENT_METHOD_TYPE.NAPAS_ACCOUNT:
        return iconPaymentMethodNapasAccount;
      case PAYMENT_METHOD_TYPE.NAPAS_CARD:
        return iconPaymentMethodNapasCard;
      default:
        return iconMasterCard;
    }
  };

  const getPaymentMethodName = () => {
    const autoRenewName = paymentMethod?.autoRenewName;
    const name = paymentMethod?.name;

    return (
      autoRenewName?.[language] ||
      autoRenewName?.[LANGUAGE.EN] ||
      name?.[language] ||
      name?.[LANGUAGE.EN] ||
      ''
    );
  };

  const renderPaymentMethodIcon = () => {
    const src = getPaymentMethodIcon();
    const paymentMethodName = getPaymentMethodName();
    const icon = <img src={src} alt={paymentMethodName || paymentMethodType} />;

    if (!paymentMethodName) return icon;

    return (
      <Tooltip title={paymentMethodName} arrow placement="top">
        {icon}
      </Tooltip>
    );
  };

  return (
    <Box className="content-item">
      <Typography className="label">{t('newPaymentMethod')}</Typography>
      <Typography className="content">{renderPaymentMethodIcon()}</Typography>
    </Box>
  );
};

export default PaymentMethod;
